import { render, staticRenderFns } from "./UploadController.vue?vue&type=template&id=12cc141b"
import script from "./UploadController.vue?vue&type=script&lang=js"
export * from "./UploadController.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports